import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LettroDaily from "./games/LettroDaily";
import LettroTwitchDaily from "./games/LettroTwitchDaily";
import GameDirectory from "./pages/GameDirectory";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<GameDirectory />} />
        <Route path="/lettro" element={<LettroDaily />} />
        <Route path="/lettro-with-twitch" element={<LettroTwitchDaily />} />
      </Routes>
    </Router>
  );
}

export default App;